/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ who: NonNullable<unknown> }} Ui_Preview_BannerInputs */

const en_ui_preview_banner = /** @type {(inputs: Ui_Preview_BannerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You are previewing as ${i?.who}. Nothing can be changed.`)
};

/** @type {(inputs: Ui_Preview_BannerInputs) => LocalizedString} */
const ar_ui_preview_banner = en_ui_preview_banner;

/** @type {(inputs: Ui_Preview_BannerInputs) => LocalizedString} */
const he_ui_preview_banner = en_ui_preview_banner;

/** @type {(inputs: Ui_Preview_BannerInputs) => LocalizedString} */
const ur_ui_preview_banner = en_ui_preview_banner;

/** @type {(inputs: Ui_Preview_BannerInputs) => LocalizedString} */
const es_ui_preview_banner = en_ui_preview_banner;

/** @type {(inputs: Ui_Preview_BannerInputs) => LocalizedString} */
const fr_ui_preview_banner = en_ui_preview_banner;

/** @type {(inputs: Ui_Preview_BannerInputs) => LocalizedString} */
const de_ui_preview_banner = en_ui_preview_banner;

/** @type {(inputs: Ui_Preview_BannerInputs) => LocalizedString} */
const pt_ui_preview_banner = en_ui_preview_banner;

/** @type {(inputs: Ui_Preview_BannerInputs) => LocalizedString} */
const hi_ui_preview_banner = en_ui_preview_banner;

/** @type {(inputs: Ui_Preview_BannerInputs) => LocalizedString} */
const bn_ui_preview_banner = en_ui_preview_banner;

/**
* | output |
* | --- |
* | "You are previewing as {who}. Nothing can be changed." |
*
* @param {Ui_Preview_BannerInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const ui_preview_banner = /** @type {((inputs: Ui_Preview_BannerInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Preview_BannerInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ui_preview_banner(inputs)
	if (locale === "he") return he_ui_preview_banner(inputs)
	if (locale === "ur") return ur_ui_preview_banner(inputs)
	if (locale === "es") return es_ui_preview_banner(inputs)
	if (locale === "fr") return fr_ui_preview_banner(inputs)
	if (locale === "de") return de_ui_preview_banner(inputs)
	if (locale === "pt") return pt_ui_preview_banner(inputs)
	if (locale === "hi") return hi_ui_preview_banner(inputs)
	if (locale === "bn") return bn_ui_preview_banner(inputs)
	return en_ui_preview_banner(inputs)
});